"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Hue = _interopRequireDefault(require("./Hue"));

var _Saturation = _interopRequireDefault(require("./Saturation"));

var _utils = require("./utils");

require("./ColorPicker.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ColorPicker = function ColorPicker(_ref) {
  var color = _ref.color,
      onChange = _ref.onChange;
  (0, _react.useEffect)(function () {
    var colors = (0, _utils.toState)(color, 0);
    onChange(colors);
  }, []);

  var onSaturationChange = function onSaturationChange(val) {
    var colors = (0, _utils.toState)(val, color.oldHue);
    onChange(colors);
  };

  var onHueChange = function onHueChange(val) {
    var colors = (0, _utils.toState)(val, val.h || color.oldHue);
    onChange(colors);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-color-picker"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cp-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cp-sat-container"
  }, /*#__PURE__*/_react["default"].createElement(_Saturation["default"], {
    onChange: onSaturationChange,
    hsl: color.hsl,
    hsv: color.hsv
  })), /*#__PURE__*/_react["default"].createElement(_Hue["default"], {
    onChange: onHueChange,
    hsl: color.hsl
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-cp-label"
  }, color.hex));
};

ColorPicker.propTypes = {
  color: _propTypes["default"].object.isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = ColorPicker;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/ColorPicker/ColorPicker.js
// module id = 691
// module chunks = 0